<template>
  <div class="convention-hall page">
    <van-nav-bar
        class="nav-bar"
        :title="$t('game.title')"
    >

      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="convention-item">
      <div class="left">
        <van-sidebar @change="onChange" v-model="activeKey">
          <van-sidebar-item :title="$t('game.all')"  style="    line-height: 20px;" />
          <van-sidebar-item v-for="(item,key) in lotteryitem" :key="key" :title="item.name"  style="    line-height: 20px;" />
        </van-sidebar>
      </div>
      <div class="right">
        <van-pull-refresh :border="false" class="list-wrapper"  :pulling-text="$t('msg.下拉即可刷新')" v-model="isLoading" @refresh="onRefresh"  :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')">
          <van-grid :column-num="2">
            <van-grid-item @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
              <van-image class="game_item_img" :src="v.ico">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span>{{v.name}}</span>
              <span>{{v.desc}}</span>
            </van-grid-item>
          </van-grid>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      gameitem: [{},{},{},{}],
      lotteryitem: [{},{},{},{}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    back(){
      this.$router.push({path:'/'})
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("msg.刷新成功！"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data:{class:index},
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    getLotteryItem(){
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res=>{
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped>
.convention-item {
  display: flex;
  align-items: center;
  height: calc(100% - 2vw);
}
</style>
<style>
.van-grid-item__content--center{
  padding: 2.133vw 1.067vw;
}
</style>
